import React from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as actionCreators from "../../../action-creators";
import { ReducerState } from "../../../reducer";
import moment from "moment";

import ManagerComponent from "./manager-component";

import * as Model from "../../../model";
import ScenarioService from "../../../service/sfp/scenario-service";
import PPIService from "../../../service/sfp/ppi-service";
import * as LoansService from "../../../service/sfp/loans-service-2";
import * as UserDomain from "../../../domain/sfp/user-domain";

class ManagerContainer extends React.Component {
    state = {
        loading: undefined,
        loadingSee: undefined,
    };

    componentDidMount() {
        this.props.actions.setPageTitle("Scénarii de fonctionnement");
        if (this.props.currentLocalAuthority) {
            this.setState({ services: this.props.currentServices });
            this._loadScenarii(this.props.currentLocalAuthority);
        }
    }

    componentWillReceiveProps(props) {
        if (
            props.currentLocalAuthority &&
            (!this.props.currentLocalAuthority ||
                this.props.currentLocalAuthority.id !== props.currentLocalAuthority.id)
        ) {
            this.setState({ services: props.currentServices });
            this._loadScenarii(props.currentLocalAuthority);
        }
    }

    render() {
        const consulted =
            UserDomain.getProfile(this.props.me) === UserDomain.Profile.LocalAuthorityConsultant;
        return (
            <ManagerComponent
                scenarii={this.state.scenarii}
                scenario={this.state.scenario}
                me={this.props.me}
                userType={this.props.me.userType}
                ppi={this.state.ppi}
                services={this.state.services}
                loans={this.state.loans}
                consulted={consulted}
                currentLocalAuthority={this.props.currentLocalAuthority}
                isGest={
                    this.props.me &&
                    !this.props.me.consultedLocalAuthority &&
                    !this.props.me.managedLocalAuthority &&
                    this.props.me.roles.indexOf("ROLE_ADMIN") == -1 &&
                    this.props.me.roles.indexOf("ROLE_SUPER_ADMIN") == -1 &&
                    UserDomain.getProfile(this.props.me) != UserDomain.Profile.RegionAdmin
                }
                loading={this.state.loading}
                loadingSee={this.state.loadingSee}
                loadingStr={this.state.loadingStr}
                action={this.state.action}
                actionData={this.state.actionData}
                onCreate={this._handleCreateScenario.bind(this)}
                onScenarioUpdate={this._handleUpdateScenario.bind(this)}
                onScenarioUpdate1={this._handleUpdateScenario1.bind(this)}
                onScenarioCreated={this._handleScenarioCreated.bind(this)}
                onScenarioUpdated={this._handleScenarioUpdated.bind(this)}
                onScenarioDeleted={this._handleScenarioDeleted.bind(this)}
                onThemeValidated={this._handleThemeValidated.bind(this)}
                onRetroUpdated={this._handleRetroUpdated.bind(this)}
                onCustomAction={this._handleCustomAction.bind(this)}
                onHidePopup={this._handleHidePopup.bind(this)}
                onBack={this._handleHidePopup.bind(this)}
                actions={this.props.actions}
            />
        );
    }

    _loadScenarii(LA) {
        this.setState(
            {
                scenarii: null,
                ppi: null,
                services: null,
                loading: true,
                loadingStr: "Chargement des scenarii",
            },
            () => {
                ScenarioService.findScenariiByLAId(LA.id)
                    .then((r) => {
                        this._resolveFindScenarii(r);
                    })
                    .catch((r) => {
                        this._rejectFindScenarii(r);
                    });
                PPIService.findPPIByLAId(LA.id)
                    .then((r) => {
                        this._resolveFindPPI(r);
                    })
                    .catch((r) => {
                        this._rejectFindPPI(r);
                    });
                LoansService.findLoans(this.props.currentLocalAuthority)
                    .then((r) => this._resolveFindLoans(r))
                    .catch((r) => {
                        this._rejectFindLoans(r);
                    });
            }
        );
    }

    _dispatchReceiveError(error) {
        this.props.actions.throwError(error);
        //this.setState({loading: false});
    }

    _resolveFindScenarii(response) {
        const scenarii = response;
        var ordered = [];
        const currentYear = parseInt(moment().format("YYYY"));

        ordered.push({ year: currentYear + 1, scenarii: [] });
        ordered.push({ year: currentYear, scenarii: [] });

        var year;
        scenarii.map((scenario) => {
            if (!ordered.find((o) => o.year == scenario.year)) {
                ordered.push({ year: scenario.year, scenarii: [] });
            }
            year = ordered.find((o) => o.year == scenario.year);
            year.scenarii.push(scenario);
        });

        ordered.sort((a, b) => {
            if (a.year > b.year) {
                return -1;
            }
            if (a.year < b.year) {
                return 1;
            }
            return 0;
        });
        const scenario = ordered.filter((item) => item.year == currentYear)[0]
            .scenarii[0];
        this.setState({
            loading: this.state.ppi && this.state.loans ? false : true,
            scenarii: ordered,
            scenario: scenario,
        });
    }

    _rejectFindScenarii(error) {
        this._dispatchReceiveError(error);
    }

    _resolveFindPPI(response) {
        const ppi = response;
        this.setState({ ppi: response });
        this.setState({
            ppi: response,
            loading: this.state.scenarii && this.state.loans ? false : true,
        });
    }

    _rejectFindPPI(error) {
        this.setState({
            ppi: { investment_themes: [], years: [], expenses: [], revenues: [] },
            loading:
                this.state.services && this.state.scenarii && this.state.loans
                    ? false
                    : true,
        });
    }

    _resolveFindLoans(response) {
        const loans = response;
        this.setState({
            loans,
            loading: this.state.scenarii && this.state.ppi ? false : true,
        });
    }

    _rejectFindLoans(error) {
        this._dispatchReceiveError(error);
    }

    _handleCustomAction(data) {
        if (data.action === "see_scenario") {
            this.setState({ loadingSee: true }, () => {
                setTimeout(() => {
                    var newState = data;

                    if (data.actionData.scenario) {
                        newState.scenario = data.actionData.scenario;
                    }
                    this.setState(newState);
                    this.setState({ newState }, () => {
                        this.setState({ loadingSee: false });
                    });
                }, 200);
            });
        } else {
            var newState = data;
            if (data.actionData.scenario) {
                newState.scenario = data.actionData.scenario;
            }
            this.setState(newState);
        }
    }
    _handleUpdateScenario(scenario, year, value) {
        /*this.setState(prevState => ({
          scenario: {
            ...prevState.scenario,
            ...scenario,
            years: prevState.scenario.years.map(y => y.year === year ? {...y, previous: value} : y)
          }
        }))*/

        this.setState({ scenario });
    }
    _handleUpdateScenario1(scenario, pos) {
        this.setState({ scenario });
        setTimeout(() => {
            const data = document.querySelector(".wtHolder");
            data.scrollTo(pos.left, pos.top);
        }, 10);
    }
    _handleHidePopup() {
        var action = null,
            actionData = null;
        if (this.state.action == "toggle_valid_theme") {
            action = "manage_scenario";
        }
        if (this.state.action == "toggle_valid") {
            action = "equilibrage_scenario";
        }
        this.setState({ action, actionData });
    }

    _handleCreateScenario() {
        this.setState({ action: "create_scenario" });
    }

    _handleScenarioCreated(scenario) {
        var scenarii = this.state.scenarii;
        var year = scenarii.find((year) => year.year == scenario.year);
        year.scenarii.push(scenario);
        this.setState({ action: null, actionData: null, scenarii });
    }

    _handleScenarioUpdated(scenario) {
        var scenarii = this.state.scenarii;
        var year = scenarii.find((year) => year.year == scenario.year);
        var year_scenarii = [];
        year.scenarii.map((s) => {
            if (s.id == scenario.id) {
                year_scenarii.push(scenario);
            } else {
                year_scenarii.push(s);
            }
        });
        if (scenario.validated) {
            year_scenarii
                .filter((s) => s.id !== scenario.id)
                .map((s) => {
                    s.validated = false;
                });
        } else {
            var s = year_scenarii.find((s) => s.id == scenario.id);
            s.validated = false;
        }
        year.scenarii = year_scenarii;
        this.setState({ action: null, actionData: null, scenarii });
    }

    _handleScenarioDeleted(scenario) {
        scenario = JSON.parse(scenario);
        var scenarii = this.state.scenarii;
        var year = scenarii.find((year) => year.year == scenario.year);
        var year_scenarii = [];
        year.scenarii.map((s) => {
            if (s.id !== scenario.id) {
                year_scenarii.push(s);
            }
        });
        year.scenarii = year_scenarii;
        this.setState({ action: null, actionData: null, scenarii });
    }

    _handleThemeValidated(theme, validate, toggle) {
        if (toggle == "toggle_valid_theme") {
            var scenario = this.state.scenario;
            var validator = scenario.validated_themes.find(
                (vt) => vt.theme_id == theme.id
            );
            if (validator) {
                validator.validated = validate;
            } else {
                scenario.validated_themes.push({
                    theme_id: theme.id,
                    validated: validate,
                });
            }

            ScenarioService.validTheme(this.state.scenario, theme, validate).then(
                null,
                this._dispatchReceiveError.bind(this)
            );
            this.setState({ scenario, action: "manage_scenario" });
        } else {
            var scenario = this.state.scenario;
            var validator = scenario.validated_themes.find(
                (vt) => vt.theme_id == theme.id
            );
            if (validator) {
                validator.validated = validate;
            } else {
                scenario.validated_themes.push({
                    theme_id: theme.id,
                    validated: validate,
                });
            }

            ScenarioService.validThemearbitrage(
                this.state.scenario,
                theme,
                validate
            ).then(null, this._dispatchReceiveError.bind(this));
            this.setState({ scenario, action: "manage_scenario" });
        }
    }

    _handleRetroUpdated(/** @type {Model.Observation[]} */ observations) {
        this.setState({ action: null, actionData: null });
    }

    _dispatchReceiveError(error) {
        this.props.actions.throwError(error);
        //this.setState({loading: false});
    }
}

const mapStateToProps = (/** @type {ReducerState} */ state) => ({
    currentLocalAuthority: state.currentLocalAuthority,
    currentServices: state.currentLocalAuthorityServices,
    me: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerContainer);



// WEBPACK FOOTER //
// ./src/component/scenarii/manager/manager-container.js